
import React, { useState } from "react";
import { C, RC, apiFetch } from "../utils/api";

export default function Proyectos({proyectos, onSelect, user, loadProyectos}) {
  console.log('PROYECTOS:', proyectos);
  const [showForm, setShowForm] = useState(false);
  const [data, setData] = useState({nombre:"", descripcion:"", lat:"3.8397", lng:"-76.5220", zoom:"14"});
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const submit = async()=>{
    if(!data.nombre){ setErr("Nombre requerido"); return; }
    setSaving(true);
    const r = await apiFetch("/proyectos.php", {
      method:"POST", headers:{"Content-Type":"application/json"},
      body: JSON.stringify(data)
    });
    setSaving(false);
    if(r.success){ setShowForm(false); setData({nombre:"",descripcion:"",lat:"3.8397",lng:"-76.5220",zoom:"14"}); loadProyectos(); }
    else setErr(r.error||"Error al guardar");
  };

  const deleteProyecto = async(id)=>{
    if(!window.confirm("Eliminar proyecto?")) return;
    await apiFetch("/proyectos.php", {method:"DELETE", headers:{"Content-Type":"application/json"}, body:JSON.stringify({id})});
    loadProyectos();
  };

  return (
    <div style={{minHeight:"100vh",background:C.primary,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"1.5rem"}}>
      <div style={{marginBottom:"1.5rem",textAlign:"center"}}>
        <div style={{fontSize:48,marginBottom:8}}>🗺</div>
        <h1 style={{color:C.white,fontSize:22,fontWeight:700,margin:0}}>Sistema FTTH</h1>
        <p style={{color:"#90CAF9",fontSize:13,margin:"4px 0 0"}}>Selecciona una zona de trabajo</p>
      </div>

      <div style={{width:"100%",maxWidth:400}}>
        <div onClick={()=>onSelect(null)} style={{background:"rgba(255,255,255,0.15)",borderRadius:12,padding:"16px",marginBottom:10,cursor:"pointer",display:"flex",alignItems:"center",gap:12,border:"2px solid rgba(255,255,255,0.3)"}}>
          <div style={{fontSize:24}}>🌐</div>
          <div>
            <p style={{margin:0,color:C.white,fontWeight:600,fontSize:15}}>Ver todas las zonas</p>
            <p style={{margin:0,color:"#90CAF9",fontSize:12}}>Muestra todos los equipos y redes</p>
          </div>
        </div>

        {proyectos.map(p=>(
          <div key={p.id} style={{background:C.white,borderRadius:12,padding:"14px",marginBottom:10,display:"flex",alignItems:"center",gap:12}}>
            <div onClick={()=>onSelect(p)} style={{flex:1,cursor:"pointer",display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:44,height:44,borderRadius:10,background:C.accent,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,color:"#fff",fontWeight:700,flexShrink:0}}>
                {p.nombre.charAt(0).toUpperCase()}
              </div>
              <div>
                <p style={{margin:0,fontWeight:600,fontSize:15,color:C.text}}>{p.nombre}</p>
                <p style={{margin:0,fontSize:12,color:C.muted}}>{p.descripcion||"Sin descripcion"}</p>
              </div>
            </div>
            {RC.includes(user.rol) && (
              <button onClick={()=>deleteProyecto(p.id)} style={{padding:"4px 8px",background:"#FEE2E2",color:"#991B1B",border:"none",borderRadius:6,fontSize:11,cursor:"pointer",flexShrink:0}}>X</button>
            )}
          </div>
        ))}

        {RC.includes(user.rol) && !showForm && (
          <button onClick={()=>setShowForm(true)} style={{width:"100%",padding:"12px 0",background:"rgba(255,255,255,0.15)",color:C.white,border:"2px dashed rgba(255,255,255,0.3)",borderRadius:12,fontSize:14,cursor:"pointer",marginTop:4}}>
            + Nueva zona
          </button>
        )}

        {showForm && (
          <div style={{background:C.white,borderRadius:12,padding:"1rem",marginTop:10}}>
            <p style={{margin:"0 0 12px",fontWeight:600,fontSize:14}}>Nueva zona</p>
            {[["nombre","Nombre *"],["descripcion","Descripcion"],["lat","Latitud centro"],["lng","Longitud centro"]].map(([k,l])=>(
              <div key={k} style={{marginBottom:10}}>
                <label style={{fontSize:12,color:C.muted,display:"block",marginBottom:3}}>{l}</label>
                <input value={data[k]} onChange={e=>setData(d=>({...d,[k]:e.target.value}))}
                  style={{width:"100%",padding:"8px 10px",borderRadius:8,border:"1px solid "+C.border,fontSize:14,boxSizing:"border-box"}}/>
              </div>
            ))}
            {err && <p style={{color:"#E53E3E",fontSize:12,margin:"0 0 8px"}}>{err}</p>}
            <div style={{display:"flex",gap:8}}>
              <button onClick={submit} disabled={saving} style={{flex:1,padding:"10px 0",background:C.accent,color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:600,cursor:"pointer"}}>{saving?"Guardando...":"Crear"}</button>
              <button onClick={()=>setShowForm(false)} style={{flex:1,padding:"10px 0",background:"#F5F7FA",color:C.text,border:"1px solid "+C.border,borderRadius:8,fontSize:13,cursor:"pointer"}}>Cancelar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
